module.exports = __webpack_public_path__ + "img/php.cd93fedf.svg";